module.exports = require("core-js/library/fn/get-iterator");